


















































import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { BPopover } from 'bootstrap-vue';
import Option from '@/_shared/interfaces/filter/option.interface';

@Component({
  components: {
    InfiniteLoading: () => import('vue-infinite-loading'),
    BPopover,
  },
})
export default class SearchComponent extends Vue {
  @Prop({
    type: String,
    required: true,
  })
  public placeholder!: string;

  @Prop({
    type: String,
    default: '',
  })
  public searchString!: string;

  @Prop({
    type: Boolean,
    default: false,
  })
  public hasResultList!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  })
  public loadingResults!: boolean;

  @Prop({
    type: Array,
    default: () => ([]),
  })
  public results!: Option[];

  resultsVisibilityFlag = false;
  localSearchString = '';

  get filterText(): string {
    return this.searchString;
  }

  set filterText(value: string) {
    this.resultsVisibilityFlag = !!value;
    this.$emit('update:search-string', value);
  }

  get showSearchButton() {
    return !this.hasResultList || (this.hasResultList && !this.loadingResults);
  }

  get showResultsContainer(): boolean {
    return this.hasResultList && !!this.results.length && this.resultsVisibilityFlag;
  }

  public updateFilter(): void {
    if (this.hasResultList) {
      this.$emit('search-results', this.localSearchString);
      return;
    }
    this.$emit('updateFilter', this.localSearchString);
  }

  public setItem(value: string) {
    this.filterText = value;
    this.localSearchString = value;
    this.$emit('updateFilter', this.localSearchString);
    this.resultsVisibilityFlag = false;
  }

  handleKeyupEnter(): void {
    if (!this.hasResultList) {
      this.$emit('updateFilter', this.localSearchString);
    }
  }

  handleKeyupTrigger(): void {
    if (this.hasResultList) {
      this.updateFilter();
    }
  }

  handleFocusIn() {
    if (!this.hasResultList || !this.results.length) return;
    this.resultsVisibilityFlag = true;
  }

  handleFocusOut() {
    setTimeout(() => {
      this.resultsVisibilityFlag = false;
    }, 100);
  }
}
